/** @type {import('../help-index.js').HelpSidebarItem} */
export const MET_HOT_SUMMARY_ITEM = {
  id: 'hotel_summary',
  screenId: 'met-hot-summary',
  label: 'Resumen',
  description: 'Ocupación, ADR, RevPAR e ingresos hoteleros.',
  detail: {
    sections: [
      {
        title: 'Para qué sirve',
        intro: 'Indicadores clave del hotel: reservas, noches vendidas, ocupación, tarifa promedio (ADR), RevPAR e ingresos.',
      },
      {
        title: 'Período',
        bullets: ['Atajos de fecha como en otras métricas.', 'Unificar monedas para totales en ARS.'],
      },
      {
        title: 'Gráficos',
        paragraphs: ['Tortas, barras y apilados según habitaciones, canales o estado de reserva.'],
      },
    ],
  },
}

/** @type {import('../help-index.js').HelpSidebarItem} */
export const MET_HOT_DETAIL_ITEM = {
  id: 'hotel_detail',
  screenId: 'met-hot-detail',
  label: 'Detalle',
  description: 'Detalle diario de ocupación e ingresos.',
  detail: {
    sections: [
      {
        title: 'Para qué sirve',
        intro: 'Desglose día a día (o por habitación) para auditar ocupación e ingresos del hotel.',
      },
      {
        title: 'Uso',
        paragraphs: ['Elegí el período y revisá la tabla detallada.'],
      },
    ],
  },
}
